import { render } from "./Form.vue?vue&type=template&id=bd125508&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=bd125508&scoped=true&lang=css"
import "./Form.vue?vue&type=style&index=1&id=bd125508&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd125508"]])

export default __exports__